import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  AFF_BALANCES_DOWNLOAD_REPORT_MUTATION_KEY,
  AFF_BALANCES_DOWNLOAD_REPORT_URL,
  AFF_BALANCES_PERMISSIONS,
} from '../constants';

export default function useDownloadAffBalancesReportMutation(): IContextMutationResult<
  void,
  Error,
  IDownloadListReportPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [AFF_BALANCES_DOWNLOAD_REPORT_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      AFF_BALANCES_DOWNLOAD_REPORT_URL,
      payload,
      { permission: AFF_BALANCES_PERMISSIONS.DOWNLOAD_LIST },
    ),
  });
}
